import { Col, Divider, Row } from 'antd';
import InfoClients from './info_clients';

const GeneralClientInfo = () => {

  return (
    <Row>
      <Col xs={24} lg={24}>
        <div style={{ fontSize: '1.1em', fontWeight: 'bold' }}>Estado del pedido</div>
        <Divider />
        <InfoClients />
      </Col>
    </Row>
  );
}

export default GeneralClientInfo;
